import { useQueryClient } from '@tanstack/react-query';

import { useAuth } from '@/contexts/auth-context';
import { useOrganization } from '@/contexts/organization-context';

import type { QueryClient } from '@tanstack/react-query';

const UNREAD_COUNT_KEY = 'unread-count';

export function invalidateAll(qc: QueryClient, orgId: string | null, userId: string | undefined) {
  qc.invalidateQueries({ queryKey: ['notifications', orgId, userId] }).catch(() => {
    /* fire-and-forget invalidation */
  });
  qc.invalidateQueries({ queryKey: ['notifications', UNREAD_COUNT_KEY, orgId, userId] }).catch(
    () => {
      /* fire-and-forget invalidation */
    },
  );
  qc.invalidateQueries({ queryKey: ['notifications', 'counts', orgId, userId] }).catch(() => {
    /* fire-and-forget invalidation */
  });
}

export function invalidateList(qc: QueryClient, orgId: string | null, userId: string | undefined) {
  qc.invalidateQueries({ queryKey: ['notifications', orgId, userId] }).catch(() => {
    /* fire-and-forget invalidation */
  });
  qc.invalidateQueries({ queryKey: ['notifications', 'counts', orgId, userId] }).catch(() => {
    /* fire-and-forget invalidation */
  });
}

export function useNotificationContext() {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const { currentOrganizationId } = useOrganization();
  return { queryClient, user, currentOrganizationId };
}

type NotificationBatchAction = 'markedRead' | 'markedUnread' | 'dismissed';
type CountTranslate = (key: string, options: { count: number }) => string;

/**
 * Resolve the count-aware toast title for a batch notification action, selecting
 * the singular or plural catalog key from `toasts.<action>One|Other`.
 */
export function pluralNotificationTitle(
  t: CountTranslate,
  action: NotificationBatchAction,
  count: number,
): string {
  const key = count === 1 ? `toasts.${action}One` : `toasts.${action}Other`;
  return t(key, { count });
}
